import { HelpCenterTopic } from '../../store/ducks/help-center/types';

const NOT_AVAILABLE = 'N/A';

const isAvailable = (value?: string) => !!value && value !== NOT_AVAILABLE;

export const splitTopics = (topics: HelpCenterTopic[]) => ({
  questions: topics.filter(
    (item) => item.type === 'question' && isAvailable(item.description)
  ),
  manuals: topics.filter(
    (item) => item.type === 'manual' && isAvailable(item.file)
  )
});
